module.exports = __webpack_public_path__ + "img/yellowDiscard.813bb848.svg";